import React, { useEffect, useRef, useState } from 'react';

import './index.module.less';

import { paths, deviceAuthStatus } from '@helpers/Constants';
import BrowserHistory from '@helpers/BrowserHistory';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import FridayService from '@services/friday';

import NavBar from '@components/NavBar';
import ConfirmModal from '@components/ConfirmModal'
import CommonBtn from '@components/CommonBtn';
import Toast from '@widgets/Toast';

import imgIconUrl from '@images/empty/empty_welcome.png';

const DeviceInfoAuthorization = () => {
  const [authDetail, setAuthDetail] = useState(null);
  const [bindInfo, setBindInfo] = useState(null);
  const params = useRef(Filter.urlParams(window.location.search));

  const getInfo = async () => {
    const deviceInfo = await Http.post(Api.GetDeviceBindInfo, {
      snCode: params.current.sncode,
      company: 'lingge',
    });
    const info = deviceInfo?.data;
    setBindInfo(info);
    if (info?.bindSchoolUid) {
      const { data } = await Http.post(Api.GetStudentCardUserAuth, {
        unitUid: info?.bindSchoolUid,
        userUid: info?.bindUserUid,
        snCode: params.current.sncode,
      });
      setAuthDetail(data);
      const text = getStatusText(data).text;
      FridayService.addEvent('device_information_authorization_to_school_page_itself_display', {
        type: text
      })
    }
  };

  const getAuthInfo = async () => {
    const { data } = await Http.post(Api.GetStudentCardUserAuth, {
      unitUid: bindInfo.bindSchoolUid,
      userUid: bindInfo.bindUserUid,
      snCode: params.current.sncode,
    });
    setAuthDetail(data);
  };

  const toApplyDetail = () => {
    BrowserHistory.push(
      `${PUBLIC_URL}${paths.deviceAuthorizationApply}?schoolUid=${bindInfo.bindSchoolUid}&studentUid=${bindInfo.bindUserUid}`,
    );
  };

  const updateAuthorization = async () => {
    console.log('update');
    await Http.post(Api.PostStudentCardUserAuth, {
      unitUid: bindInfo.bindSchoolUid,
      userUid: bindInfo.bindUserUid,
      snCode: params.current.sncode,
    });
    getAuthInfo();
    Toast.show({
      title: '授权成功',
      type: 'strip',
    });
  };

  const revertAuthorization = async () => {
    ConfirmModal.show({
      title: '确认撤销授权？',
      showCancelBtn: true,
      text: '撤销后，学校将无法通过设备信息进一步保证孩子的在校安全。',
      cancelBtnText: '取 消',
      confirmBtnText: '撤 销',
      confirmTheme: 'warn',
      onConfirm: async () => {
        await Http.post(Api.DeleteStudentCardUserAuth, {
          unitUid: bindInfo.bindSchoolUid,
          userUid: bindInfo.bindUserUid,
          snCode: params.current.sncode,
        });
        Toast.show({
          title: '撤销授权',
          type: 'strip',
        });
        getAuthInfo();
      }
    });
  };

  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getStatusText = (detail?: { status: number }) => {
    const authInfo = detail || authDetail;
    let text = '未知';
    let textStyle = {};
    switch (authInfo?.status) {
      case deviceAuthStatus.allAuth:
        text = '已授权';
        textStyle = { color: '#00A870' };
        break;
      case deviceAuthStatus.noAuth:
        text = '未授权';
        break;
      case deviceAuthStatus.partAuth:
        text = '部分授权';
        textStyle = { color: '#FF8026' };

        break;
    }
    return { text, textStyle };
  };

  const renderAuthButton = () => {
    let Button = null;
    if (!authDetail) {
      return null;
    }
    switch (authDetail.status) {
      case deviceAuthStatus.noAuth:
        Button = (
          <CommonBtn
            type="fixed"
            btnText="同意授权"
            onConfirm={updateAuthorization}
          />
        );
        break;
      case deviceAuthStatus.partAuth:
        Button = (
          <div className="flex" styleName="bottom-btn">
            <div
              className="flex flex-center"
              styleName="btn-cancel"
              onClick={revertAuthorization}
            >
              撤销授权
            </div>
            <div
              className="flex flex-center"
              styleName="btn-confirm"
              onClick={updateAuthorization}
            >
              同意变更授权
            </div>
          </div>
        );
        break;
      case deviceAuthStatus.allAuth:
        Button = (
          <CommonBtn
            type="fixed"
            btnText="撤销授权"
            onConfirm={revertAuthorization}
            style={{
              background: '#F2F4F7',
              color: '#55585C',
            }}
          />
        );
        break;
      // no default
    }
    return Button;
  };

  return (
    <div className="flex container" styleName="container">
      <NavBar title="对学校授权" transparent />
      <div className="flex" styleName="card-wrapper">
        <div className="flex" styleName="card">
          <img styleName="card-img" src={imgIconUrl} alt="" />
          <div styleName="card-popup">
            您当前的授权状态：
            <span style={getStatusText().textStyle}>
              {getStatusText().text}
            </span>
          </div>
        </div>
        <div styleName="content">
          <div styleName="content-title">授权内容</div>
          <div className="flex" styleName="content-item-wrapper">
            {authDetail
              ? authDetail?.resourceAuthDtos.map(
                  (item: {
                    resourceCoverUrl: string;
                    resourceName:
                      | boolean
                      | React.ReactChild
                      | React.ReactFragment
                      | React.ReactPortal;
                  }) => {
                    return (
                      <div className="flex" styleName="content-item">
                        <img
                          styleName="item-img"
                          src={item.resourceCoverUrl}
                          alt=""
                        />
                        <div styleName="item-text">{item.resourceName}</div>
                      </div>
                    );
                  },
                )
              : []}
          </div>
        </div>
        {authDetail ? (
          <div styleName="tips">
            {authDetail?.status === deviceAuthStatus.allAuth
              ? '为了保证孩子的在校安全，学校可以使用以上信息和权限，详见'
              : '同意授权后，学校将可以使用以上全部信息和权限来保证孩子的在校安全，详见'}
            <span styleName="tips-link" onClick={toApplyDetail}>
              《学校个人信息授权使用声明及授权同意书》
            </span>
          </div>
        ) : null}
      </div>
      {renderAuthButton()}
    </div>
  );
};

export default DeviceInfoAuthorization;
